import React from 'react';
import { useOutletContext } from 'react-router-dom';
import { RestaurantGuardOutletContext } from '../../routes/RestaurantGuard';
import { InfoCallout } from './InfoCallout';
import { useTranslation } from 'react-i18next';

export const PatioInfoSection = () => {
	const { restaurant } = useOutletContext<RestaurantGuardOutletContext>();
	const { t } = useTranslation();

	return (
		<InfoCallout>
			{t('messages.patio_assignment_prefix', { defaultValue: 'By choosing this selection, you will be assigned to a table within' })}{' '}
			{restaurant.displayName}
			{restaurant.displayName.endsWith('\'s')
				? ''
				: restaurant.displayName.endsWith('s')
					? '\''
					: '\'s'}{' '}
			{t('messages.patio_suffix', { defaultValue: 'Patio.' })}
		</InfoCallout>
	);
};